console.log('Dynamic production fee script starting');

const PRODUCTION_FEE_VARIANT_ID = 49222880756002; // Your actual variant ID
const MINIMUM_ORDER_VALUE = 4900; // £250.00 in cents

function debugLog(message) {
  console.log(`[Production Fee Debug] ${message}`);
}

function isCartPage() {
  return window.location.pathname.includes('/cart');
}

function getCart() {
  debugLog('Fetching cart data');
  return fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      debugLog(`Cart fetched. Total price: ${cart.total_price}, Item count: ${cart.item_count}`);
      return cart;
    });
}

function updateCart(updates) {
  debugLog(`Updating cart: ${JSON.stringify(updates)}`);
  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: updates })
  })
  .then(response => response.json());
}

async function handleProductionFee() {
  const cart = await getCart();
  const cartTotalWithoutFee = cart.items.reduce((total, item) => 
    item.variant_id !== PRODUCTION_FEE_VARIANT_ID ? total + item.final_line_price : total, 0);
  const productionFeeItem = cart.items.find(item => item.variant_id === PRODUCTION_FEE_VARIANT_ID);
  const currentFeeQuantity = productionFeeItem ? productionFeeItem.quantity : 0;

  debugLog(`Cart Total Without Fee: ${cartTotalWithoutFee}, Current Fee Quantity: ${currentFeeQuantity}`);

  if (cartTotalWithoutFee < MINIMUM_ORDER_VALUE) {
    const requiredFee = MINIMUM_ORDER_VALUE - cartTotalWithoutFee;
    if (requiredFee !== currentFeeQuantity) {
      debugLog(`Updating production fee to: ${requiredFee}`);
      await updateCart({ [PRODUCTION_FEE_VARIANT_ID]: requiredFee });
      return true;
    }
  } else if (currentFeeQuantity > 0) {
    debugLog('Removing production fee');
    await updateCart({ [PRODUCTION_FEE_VARIANT_ID]: 0 });
    return true;
  }
  return false;
}

function hideControlsForProductionFee() {
  if (!isCartPage()) return;
  
  const cartItems = document.querySelectorAll('.cart-item');
  cartItems.forEach(item => {
    if (item.innerHTML.includes('Minimum Production Fee')) {
      const quantityWrapper = item.querySelector('.cart-item__quantity-wrapper');
      const removeButton = item.querySelector('cart-remove-button');
      if (quantityWrapper) quantityWrapper.style.display = 'none';
      if (removeButton) removeButton.style.display = 'none';
    }
  });
}

function hideProductionFeePricing() {
  if (!isCartPage()) return;
  
  const cartItems = document.querySelectorAll('.cart-item');
  cartItems.forEach(item => {
    if (item.innerHTML.includes('Production Fee')) {
      // Find and hide the £0.01 price
      const priceElements = item.querySelectorAll('div');
      priceElements.forEach(el => {
        if (el.textContent.trim() === '£0.01') {
          el.style.display = 'none';
        }
      });

      // Hide the quantity input
      const quantityInput = item.querySelector('input[type="number"]');
      if (quantityInput) {
        const quantityWrapper = quantityInput.closest('.cart-item__quantity-wrapper');
        if (quantityWrapper) quantityWrapper.style.display = 'none';
      }

      // Hide the remove button
      const removeButton = item.querySelector('cart-remove-button');
      if (removeButton) removeButton.style.display = 'none';
    }
  });
}

function applyStyles() {
  const style = document.createElement('style');
  style.textContent = `
    .cart-item:has(.cart-item__name:contains("Production Fee")) .cart-item__quantity-wrapper,
    .cart-item:has(.cart-item__name:contains("Production Fee")) cart-remove-button {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
}

let isProcessing = false;

async function runProductionFeeLogic() {
  if (!isCartPage() || isProcessing) return;
  
  isProcessing = true;
  debugLog('Running production fee logic');
  try {
    const changesMade = await handleProductionFee();
    if (changesMade) {
      debugLog('Changes made, updating cart view');
      location.reload();
    } else {
      hideProductionFeePricing();
      applyStyles();
    }
  } catch (error) {
    console.error('Error in production fee logic:', error);
  } finally {
    isProcessing = false;
  }
}

function observeCartChanges() {
  const cartForm = document.querySelector('form[action="/cart"]');
  if (!cartForm) return;

  const observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        runProductionFeeLogic();
        break;
      }
    }
  });

  observer.observe(cartForm, { childList: true, subtree: true });
}

document.addEventListener('cart:updated', (event) => {
  if (isCartPage()) {
    debugLog('Cart updated event fired');
    runProductionFeeLogic();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  debugLog('DOM loaded');
  if (isCartPage()) {
    runProductionFeeLogic();
    observeCartChanges();
  }
});

// Listener for quantity changes
document.addEventListener('change', (event) => {
  if (isCartPage() && event.target.matches('.quantity__input')) {
    debugLog('Quantity changed');
    runProductionFeeLogic();
  }
});

window.addDynamicProductionFee = runProductionFeeLogic;

console.log('Dynamic production fee script finished loading');